import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "peso", "talla", "modality", "submit"]

  connect() {
    this.validate()
  }

  validate() {
    if (!this.hasSubmitTarget) return

    const peso = this.hasPesoTarget ? this.pesoTarget.value.trim() : ""
    const talla = this.hasTallaTarget ? this.tallaTarget.value.trim() : ""
    const modality = this.hasModalityTarget ? this.modalityTarget.value.trim() : ""
    const practicesCount = this.selectedPracticesCount()
    const requiresWeightHeight = this.tomografiaModality(modality)
    const decimalPattern = /^\d+(?:[.,]\d+)?$/

    const pesoOk = !requiresWeightHeight || decimalPattern.test(peso)
    const tallaOk = !requiresWeightHeight || decimalPattern.test(talla)

    const valid =
      pesoOk &&
      tallaOk &&
      modality.length > 0 &&
      practicesCount > 0

    this.submitTarget.disabled = !valid
  }

  tomografiaModality(modality) {
    return modality.toLowerCase().includes("tomografia")
  }

  selectedPracticesCount() {
    if (!this.hasFormTarget) return 0

    return this.formTarget.querySelectorAll(
      'input[name*="turno_tratamiento_previo_descripciones_attributes"][name*="descripcion_imagen_id"]'
    ).length
  }
}
